import LotCard from '@/components/lot/LotCard';
import SortableLotProcess from '@/components/lot/SortableLotProcess';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn-ui/select';
import { getLotById } from '@/network/api.service';
import { CreateLotProcessSchema } from '@/schema/process-lot-schema';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

const DefineProcessStepPage = () => {
  const [lot, setLot] = useState();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const fetchLot = async () => {
      const { data } = await getLotById(id, false);

      if (data?.data) {
        setLot(data.data);
      }
    };
    fetchLot();
  }, []);

  const methods = useForm({
    resolver: yupResolver(CreateLotProcessSchema),
    defaultValues: {
      type_of_processing: lot?.type_of_processing || '',
      processing_steps: Array.isArray(lot?.processing_steps)
        ? lot.processing_steps
        : [
            {
              sequence: 1,
              name: '',
              status: 'Yet to start',
            },
          ],
    },
    mode: 'onBlur',
  });
  const {
    control,
    watch,
    formState: { errors },
  } = methods;
  const typeOfProcessing = watch('type_of_processing');

  return (
    <FormProvider {...methods}>
      <div className="flex flex-1 flex-col space-y-[18px] px-4 py-[18px]">
        <LotCard lot={lot} edit={true} />

        <div>
          <div className="mb-1 font-medium">Type of processing*</div>
          <Controller
            name="type_of_processing"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Select value={field.value || ''} onValueChange={field.onChange}>
                <SelectTrigger className="rounded-[10px] bg-white text-sm">
                  <SelectValue placeholder="Select processing" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Natural">Natural</SelectItem>
                  <SelectItem value="Honey">Honey</SelectItem>
                  <SelectItem value="Washed">Washed</SelectItem>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        <div>
          {/* <div className="mb-1 font-medium">Processing steps*</div> */}
          {typeOfProcessing ? (
            <div>
              <div className="mb-1 font-medium">Processing steps*</div>
              <div className="text-sm text-red-500">{errors?.processing_steps?.message}</div>
              <div className="mt-1">
                <SortableLotProcess id={id} />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </FormProvider>
  );
};

export default DefineProcessStepPage;
